'use strict';

import { settingsData } from '../../settings';
import { getHighlights } from '../threejs/autoSelectionBoxes';
import {
	Box3,
	MathUtils,
	Spherical,
	Vector3,
} from 'three';
import { Report } from './QAReport';

const FACING = {
	"דרום": {
		"en": "South",
		"ru": "",
		"he": "דרום"
	},
	
	"צפון": {
		"en": "North",
		"ru": "",
		"he": "צפון"
	},
	"מזרח": {
		"en": "East",
		"ru": "",
		"he": "מזרח"
	},
	
	"מערב": {
		"en": "West",
		"ru": "",
		"he": "מער"
	}
};

const North = new Vector3();
const East = new Vector3();
const South = new Vector3();
const West = new Vector3();
const _vec1 = new Vector3();
const _vec2 = new Vector3();
const _box = new Box3();
const _axis = new Vector3(0,-1,0).normalize();
const Distance = 100;


export class Exposure extends Report{
	constructor () {
		super('Exposure');
		this.message = 'Invalid exposure direction';
		this.compass = config.threejs.compass.correction;
		this.crm = JSON.parse(JSON.stringify(settingsData.allCrmData));
		this.hightlights = getHighlights();
		this.from = new Vector3();
		this.to = new Vector3();
		this.direction = new Vector3();
		this.sperical = new Spherical();
	}
	
	validate() {
		if (this.jsonReport.length) {
			this.showReport();
			return;
		}
		
		this.crm.forEach(apt => {
			this.#translateFacing(apt);
			const selectionBox = this.hightlights.getObjectByName(apt.engineId);
			if (selectionBox) {
				selectionBox.parent.getWorldPosition(this.from);
				_box.setFromObject(selectionBox);
				_box.getCenter(this.to);
				// selectionBox.getWorldPosition(this.to);
				this.from.setY(this.to.y);
				this.#setExposures(this.from);
				this.direction
					.subVectors(this.to,this.from)
					.normalize()
					.setLength(Distance)
					.add(this.from)
					.setY(this.from.y);
				
				const worldExposure = this.#getWorldExposure(this.direction,this.from);
				if (worldExposure.length === 0) {
					this.addError(apt,`World facing is empty`);
				} else {
					if (apt.facing.length === 1) {
						apt.facing.forEach(facing => {
							if (!worldExposure.includes(facing)) {
								this.addError(apt,null, worldExposure);
							}
						});
					} else {
						worldExposure.forEach(facing => {
							if (!apt.facing.includes(facing)) {
								this.addError(apt,null,worldExposure);
							}
						});
					}
				}
			} else {
				this.addError(apt,`Selection box is absent`);
			}
		});
		
		this.normalize();
		this.showReport();
	}
	
	normalize () {
		if (!this.log.length) {
			this.jsonReport.push('OK');
		} else {
			this.log.forEach(report => {
				const apartmentString = super.normalize(report.apt);
				let dataString = apartmentString + ' - ' + report.message + '. Current facing: ' + report.apt.facing.join(',');
				if (report.expected) {
					dataString += '. Expected: ' + report.expected.join(',');
				}
				this.jsonReport.push(dataString);
			});
		}
	}
	
	#setExposures(floorVector) {
		this.sperical.setFromVector3(floorVector);
		North.copy(floorVector)
			.applyAxisAngle(_axis,this.sperical.theta - this.compass + Math.PI)
			.normalize()
			.setLength(Distance)
			.add(floorVector)
			.setY(floorVector.y);
		
		East.copy(floorVector)
			.applyAxisAngle(_axis,this.sperical.theta - this.compass + Math.PI + Math.PI / 2)
			.normalize()
			.setLength(Distance)
			.add(floorVector)
			.setY(floorVector.y);
		
		West.copy(floorVector)
			.applyAxisAngle(_axis,this.sperical.theta - this.compass + Math.PI - Math.PI / 2)
			.normalize()
			.setLength(Distance)
			.add(floorVector)
			.setY(floorVector.y);
		
		South.copy(floorVector)
			.applyAxisAngle(_axis,this.sperical.theta - this.compass + Math.PI * 2)
			.normalize()
			.setLength(Distance)
			.add(floorVector)
			.setY(floorVector.y);
	}
	
	#getWorldExposure(direction,center) {
		const angles = {
			North: this.#getAngle(North,direction,center),
			East: this.#getAngle(East,direction,center),
			South: this.#getAngle(South,direction,center),
			West: this.#getAngle(West,direction,center)
		};
		
		const exposure = [];
		
		Object.entries(angles).forEach(([direction,angle]) => {
			if (angle >= 0 && angle <= 90) {
				exposure.push(direction);
			}
		});
		
		return exposure;
	}
	
	#getAngle(from,to,center) {
		_vec1.copy(from).sub(center);
		_vec2.copy(to).sub(center);
		return MathUtils.radToDeg(_vec1.angleTo(_vec2));
	}
	
	#translateFacing(apt) {
		apt.facing.forEach((face,index) => {
			apt.facing[index] = FACING[face].en
		});
	}
}
